// mobile:

if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test( navigator.userAgent ) ) {

	var isMobile = true;
	
} else {

	var isMobile = false;

};

// create cookie:

function createCookie(name, value, days) {
	
	var expires;

	if (days) {
	var date = new Date();
	date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	expires = "; expires=" + date.toGMTString();
	} else {
	expires = "";
	}
	document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";

}

// read cookie:

function readCookie(name) {
	
	var nameEQ = encodeURIComponent(name) + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
	var c = ca[i];
	while (c.charAt(0) === ' ') c = c.substring(1, c.length);
	if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
	}
	return null;

}

// erase cookie:

function eraseCookie(name) {
	
	createCookie(name, "", -1);
	
}

( function( $ ) {
	
	// exit if popup_exit_off is set
	
    if ( typeof popup_exit_off !== 'undefined' ) return false;
	
	var popup_mobile_cookie = 'popup_mobile_closed';
	
	if ( /Android|iPhone/i.test(navigator.userAgent) && !( readCookie( popup_mobile_cookie ) ) ) {
		
		if ( /iPhone/i.test( navigator.userAgent ) ) {

			var popup_mobile_url = 'https://itunes.apple.com/us/podcast/marketing-school-neil-patel/id1138869817';
			
		} else {

			var popup_mobile_url = 'https://play.google.com/music/m/Ihlfnjttfnju6xalct4l3vkd3si?t=Marketing_School_%7C_Digital_Marketing_%7C_Online_Marketing';
			
		};
			
		var popup_mobile_show	= 0;
		var popup_mobile_id		= 'popup-mobile';

		var popup_mobile_html = ''+

		'<div id="' + popup_mobile_id + '">'+

			'<p class="size-40 medium title">Learn Marketing in <span class="nl"></span> Just <span class="red">5 Minutes</span> a Day</p>'+
			
			'<p class="btn-wrap"><a class="btn btn-wrr" href="' + popup_mobile_url + '">Subscribe to Marketing School</a></p>'+

		'</div>';
		
		// wait 30 seconds
		
		setTimeout( function(){ 
		
			if ( popup_mobile_show == 0 ) {
				
				// check if another popup is open:
				
				var mfp = $.magnificPopup.instance;
				
				if( !mfp.isOpen ) { 

					createCookie( popup_mobile_cookie, '1', '365' );
					popup_mobile_show = 1;

					$.magnificPopup.open( {

						items: {

							src			: popup_mobile_html,
							type		: 'inline',
							midClick	: true 
							
						}
					
					} );
				
				};

			};
		
		}, 30000 );
	
	};
		
} )( jQuery );